<app-ion-page-content [forceOverscroll]="false">
  <div class="billboard-page">
    <div class="billboard-page__preview">
      <div class="billboard-page__preview-banner">
        @if ((platform$ | async) === platform.desktop) {
          <app-image [img]="getBilbordImage()"></app-image>
        }
        @if ((platform$ | async) !== platform.desktop) {
          <app-image
            [img]="billboardData?.avatar?.previewLarge || '/assets/images/befree.png' | addBaseUrl"
          ></app-image>
        }
      </div>
      @if (currentUser$ | async; as currentUser) {
        <div class="billboard-page__preview-info">
          <ion-grid>
            <ion-row>
              <ion-col class="avatar-col">
                <div class="billboard-page__preview-info-avatar">
                  <app-image
                    [img]="
                      (billboardData?.avatar?.previewLarge | addBaseUrl) ||
                      '/assets/images/befree.png'
                    "
                  ></app-image>
                </div>
              </ion-col>
              <ion-col>
                <div class="billboard-page__preview-info-description">
                  <app-information-card
                    [info]="billboardData | setBillboardInfo: isShowNumOfEmployees"
                  ></app-information-card>
                </div>
              </ion-col>
              @if (isNeedFavoriteLogic) {
                <ion-col size="1" class="fav-icon-col">
                  <div
                    class="fav-icon"
                    (click)="favoriteState(billboardData.isFavorite, billboardData.id)"
                  >
                    @if (!billboardData.isFavorite) {
                      <app-image [img]="'assets/images/icons-svg/not-favourite.svg'"></app-image>
                    }
                    @if (billboardData.isFavorite) {
                      <app-image [img]="'assets/images/icons-svg/favourite.svg'"></app-image>
                    }
                  </div>
                </ion-col>
              }
            </ion-row>
          </ion-grid>
          @if (
            isNeedCreatePhotoReportBtn &&
            currentUser.userDepartment.id === billboardData.id &&
            currentUser.userDepartment.type === DepartmentsType.shop
          ) {
            <div class="billboard-page__preview-info-button">
              <app-button
                [btnType]="Buttons.base"
                [textSize]="ButtonTextSizes.h6BtnSmall"
                text="Создать фотоотчёт"
                (click)="emitCreatePhotoReportModal()"
              ></app-button>
            </div>
          }
        </div>
      }
    </div>

    <div #tabs class="billboard-page__info-tabs">
      <app-block>
        <div class="tabs">
          @for (link of tabLinks; track link) {
            <a [routerLink]="link.url" [routerLinkActive]="'active'">
              <app-text
                [textSize]="TextSizes.h1Header"
                [textType]="TextType.base"
                [text]="link.name"
              ></app-text>
            </a>
          }
        </div>
        <router-outlet></router-outlet>
      </app-block>
    </div>
  </div>
</app-ion-page-content>
